module.exports = __webpack_public_path__ + "media/images/amenities_icons/monitor-42a663a9cb8b59dd6a91fdc4a17d5525.svg";